import { render } from "./ActivityArea.vue?vue&type=template&id=767e2292&scoped=true&ts=true"
import script from "./ActivityArea.vue?vue&type=script&lang=ts"
export * from "./ActivityArea.vue?vue&type=script&lang=ts"

import "./ActivityArea.vue?vue&type=style&index=0&id=767e2292&scoped=true&lang=css"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-767e2292"]])

export default __exports__